
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/publier-une-annonce-proprietaire",
      function () {
        return require("private-next-pages/publier-une-annonce-proprietaire/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/publier-une-annonce-proprietaire"])
      });
    }
  